<template>
    <hr>
    <div class="mt-3 mb-3 mt-lg-5">
        <div class="row justify-content-end">
            <div v-for="item in useMenuStore().footerBottom" class="col-sm-12 col-md-auto">
                <NuxtLink
                          :to="localePath({name: 'documents-code', params: {code: item.code}})"
                          :title="item.title"
                          :class="`mx-2 ${item.class}`"
                          :rel="item.nofollow ? 'nofollow' : ''"
                          :target="item.new_window ? '_blank' : ''">
                    {{ item.title }}
                </NuxtLink>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useMenuStore } from '~/stores/MenuStore';
import { useLocalePath } from '#imports';

const localePath = useLocalePath();
</script>
